import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { vendorListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { publicImageProps } from "../../services/config";
import DefaultImage from "../../components/common/default-image/DefaultImage";
import VendorStatusModal from "../../components/common/modals/vendor-status-modal/VendorStatusModal";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import VendorsFilter from "./VendorsFilter";

export default function VendorStoresList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [vendorData, setVendorData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [vendor, setVendor] = useState(null);

  const { utils } = useSelector(utilsState);

  const getVendor = async (params) => {
    const path = "admin/vendorStores";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setVendorData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getVendor({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getVendor(allFilter);
  };

  const data = [];

  vendorData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      showCategories: item?.categories?.length
        ? item?.categories.map((item) => {
            return <span className="text-xs">{item.name} ،</span>;
          })
        : null,
      showDiscountPercent: `${item.discountPercent}%` || 0,
      showMainImage: item.mainImage ? (
        <img
          className="w-10 h-10 rounded-md"
          {...publicImageProps(item.mainImage, { vendor: true, variant: "thumb_" })}
        />
      ) : (
        <DefaultImage imgSize={26} imgClass={"!w-10 !h-10 rounded-md"} />
      ),
      createdAt: item.createdAt,
      faStatus: item?.status || "",
      selectedBooth: item?.selectedBooth ? "بله" : "",
    })
  );

  const navigate = useNavigate();

  const chnageStatus = (singleVendor) => {
    setVendor(singleVendor);
    vendorRef.current.showModal();
  };

  const vendorRef = useRef();

  const handleEdit = (singleVendor) => {
    const newSingleVendor = vendorData.filter((item) => {
      return item._id == singleVendor.id;
    });
    console.log(newSingleVendor);
    navigate("/edit-vendor-store", { state: newSingleVendor[0] });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <VendorStatusModal
        ref={vendorRef}
        data={vendor}
        reGetData={getVendor}
        isGet={true}
      />

      <Title title={"لیست غرفه ها"} />

      <VendorsFilter filterDataHandler={filterDataHandler} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
        columns={vendorListColumns}
        rows={data}
        onCustomFunction={chnageStatus}
        onEdit={handleEdit}
        customFunctionName={"تغییر وضعیت"}
      />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
